import { render, staticRenderFns } from "./jdDeliveryInfo.vue?vue&type=template&id=58108c46"
import script from "./jdDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./jdDeliveryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports